export default __webpack_public_path__ + "static/media/Group 131.8b98ba94.png";